<div class="opened">
  <div class="colors">
    @for (paint of defaultColors; track paint) {
      <div (click)="changeColor(paint)" class="circle" [ngStyle]="{ background: paint }"></div>
    }
  </div>
  <div class="hex-code">
    <p>Hex Code</p>
    <div class="g-input">
      <input
        type="text"
        maxlength="7"
        [value]="color"
        (keyup)="changeColorManual(paintInput.value)"
        (keydown.enter)="toggleColors()"
        #paintInput
      />
    </div>
  </div>
</div>
